// extracted by mini-css-extract-plugin
export default {"toolbar":"DormTabs_toolbar__rQxYv","title":"DormTabs_title__kPTGG","tabs":"DormTabs_tabs__EzMC9","tab":"DormTabs_tab__pOjEH","active":"DormTabs_active__V8kG4"};